import { call, put, takeLatest } from "redux-saga/effects";
import toast from "react-hot-toast";
import * as types from "../actions/actionTypes";
import {
  axiosGet,
  axiosPost,
  axiosPut,
  axiosDelete,
} from "../../utils/common/axios";
import { getCategoryByIdResponse, getAllCategoryResponse } from "../actions";

export function* createCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPost(`category`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    toast.success(data?.message || "Category added successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* updateCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() =>
      axiosPut(`category/${action?.data?.payload?.id}`, action.data?.payload)
    );
    action.data?.callback?.success?.(data);
    yield put(getCategoryByIdResponse(data));
    toast.success(data?.message || "Category edited successfully.");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.data?.callback?.failure?.(e);
  }
}

export function* getCategoryByIdEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`category/2`));
    yield put(getCategoryByIdResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getCategoryByIdResponse([]));
  }
}

export function* getAllCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosGet(`category/all`));
    yield put(getAllCategoryResponse(data));
    action?.payload?.callback?.success?.(data);
  } catch (e) {
    console.log(e);
    yield put(getAllCategoryResponse([]));
  }
}

export function* deleteCategoryEffectSaga(action) {
  try {
    const { data } = yield call(() => axiosDelete(`category/4`));
    action.payload?.callback?.success?.(data);
    toast.success(data?.message || "Category deleted successfully");
  } catch (e) {
    console.log(e);
    if (e?.status !== 401) action.payload?.callback?.failure?.(e);
  }
}

export function* categoryWatcherSaga() {
  yield takeLatest(types.CREATE_CATEGORY, createCategoryEffectSaga);
  yield takeLatest(types.UPDATE_CATEGORY, updateCategoryEffectSaga);
  yield takeLatest(types.GET_CATEGORY, getCategoryByIdEffectSaga);
  yield takeLatest(types.GET_ALL_CATEGORY, getAllCategoryEffectSaga);
  yield takeLatest(types.DELETE_CATEGORY, deleteCategoryEffectSaga);
}
